<template>
  <div class="app-router">
    <h2 class="font-weight-bold">
      <div class="d-flex flex-row align-center text-uppercase">
        <v-img width="30" max-width="30" class="mr-3" src="/assets/seller/store.svg"></v-img>
        <span v-if="detailStore">{{ detailStore.store_name }}</span>
      </div>
    </h2>
    <div class="text-subtitle-2 pb-4">Berikut ini adalah ringkasan informasi tentang tokomu.</div>

    <v-card flat outlined>
      <v-card-text class="py-0">
        <v-tabs v-model="intabs">
          <v-tab class="text-caption text-capitalize font-weight-bold half-xs-width">Informasi Toko</v-tab>
          <v-tab class="text-caption text-capitalize font-weight-bold half-xs-width">Alamat Toko</v-tab>

          <v-tab-item>
            <profileData :profile="detailStore"></profileData>
          </v-tab-item>

          <v-tab-item>
            <updateAlamat></updateAlamat>
          </v-tab-item>
         </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import profileData from './components/profileData'
import updateAlamat from './components/updateAlamat'

export default {
  name: 'seller-profile-store',
  components: { profileData, updateAlamat },
  data() {
    return {
      intabs: null,
      loading: false
    }
  },
  computed: {
    ...mapState('storeSeller', ['detailStore'])
  },
  methods: {
    ...mapActions('storeSeller', ['getStoreDetail']),
  },

  async created() {
    await this.getStoreDetail()
  }
}
</script>